import type { CSSProperties, ReactElement } from 'react';

/** The six fixed inks of the recap. Deliberately not theme-aware — see styles/wrapped.css. */
export type WrappedPaint = 'night' | 'plum' | 'paper' | 'red' | 'green' | 'blue';

/** `x`/`y` are container-query offsets from the centre of the card, e.g. `'-42cqw'`, `'18cqh'`. */
export type WrappedBlob = {
  readonly paint: WrappedPaint;
  readonly x: string;
  readonly y: string;
  readonly scale: number;
};

export type WrappedSlideSpec = {
  readonly id: string;
  readonly bg: WrappedPaint;
  readonly ink: WrappedPaint;
  readonly durationMs: number;
  readonly blobs: readonly [WrappedBlob, WrappedBlob, WrappedBlob];
  /** An element, not a render function: the engine remounts it by key to replay its entrance. */
  readonly content: ReactElement;
};

/**
 * React's `CSSProperties` has no index signature, and `as` is banned, so a style object that
 * carries custom properties is typed by intersecting the two.
 */
export type StyleWithVars = CSSProperties & Readonly<Record<`--${string}`, string>>;

export const paintVar = (paint: WrappedPaint): string => `var(--${paint})`;
